// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"new-220w-bifacial-solar-panel_productcontent__tsN2a"};